import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';
import { BottomSheetProps } from '.';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 30;
`;

export const Background = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.bg400};
  opacity: 0.4;
`;

export const BottomSheetWrapper = styled(motion.div)<
  Pick<BottomSheetProps, 'fullHeight'>
>`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  max-height: 90svh;
  background-color: #1e1c24;
  border-radius: 12px 12px 0 0;
  overflow: auto;

  ${({ fullHeight }) =>
    fullHeight &&
    css`
      height: 90svh;
    `};
`;

export const BottomSheetHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
`;

export const ButtonConfirm = styled.button`
  color: ${({ theme }) => theme.palette.brand300};
  ${({ theme }) => theme.typography('$body_01')};
`;

export const BottomSheetBody = styled.div`
  position: relative;
  padding: 0 20px 20px;
`;
